<template>
  <div class="nko-detail-content">
    <h3>
      О компании
    </h3>
    <p>
      <b>
        Unilever (Юнили́вер) — британская компания, один из мировых лидеров на рынке пищевых продуктов и товаров бытовой химии (в том числе парфюмерии). Штаб-квартиры — в Лондоне (Великобритания).
      </b>
    </p>
    <p>
      Основана в 1929 году в результате объединения нидерландского производителя маргарина Margarine Unie и пионера мыловаренной промышленности британской компании Lever Brothers  с целью экономии на масштабах поставок: оба производителя массово импортировали пальмовое масло. В конце XX века вплоть до момента слияния Procter & Gamble и Gillette в 2005 году была крупнейшим производителем потребительских товаров в мире, по состоянию на 2020 год — вторая в мире по объёмам продаж.
    </p>
    <p>
      Численность персонала — 155 тыс. человек (2019), капитализация на начало 2020 года — $107 млрд, выручка (2019) — €52 млрд, прибыль (2019) — €6 млрд. Председатель совета директоров  — Нильс Андерсен, генеральный директор — Алан Джоуп.
    </p>
  </div>
</template>

<script>
export default {
  name: 'NkoDetailContent',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.nko-detail-content {
  margin-bottom: 45px;
  @include tablet{
    margin-bottom: 30px;
  }
  @include mobile{
    margin-bottom: 54px;
  }
  :deep{
    h3{
      font-family: 'Montserrat';
      font-weight: 600;
      font-size: 22px;
      line-height: 28px;
      color: #000000;
      margin-bottom: 20px;
    }
    p{
      font-size: 16px;
      line-height: 24px;
    }
    b{
      font-weight: 600;
    }
  }
}
</style>